import(/* webpackMode: "eager" */ "/vercel/path0/src/app/tr/blog/kaz-ayagi-botoksu-nedir/page.tsx");
